<template>
  <div class="amap-steps-panel" @click.stop @mousedown.stop>
    <div class="amap-steps-panel__head">
      <div class="amap-steps-panel__title">{{ title }}</div>
      <slot name="extra" />
    </div>
    <div class="amap-steps-panel__rule">{{ rule }}</div>
    <a-steps size="small" :current="saved ? items.length : current">
      <a-step
        v-for="(item, index) in items"
        :key="item.title"
        :title="item.title"
        :description="item.description"
        :status="stepStatus(index)"
        :class="{ 'is-clickable': index <= maxReached }"
        @click="onStepClick(index)"
      />
    </a-steps>
    <div v-if="hint" class="amap-steps-panel__hint">{{ hint }}</div>
    <div class="amap-steps-panel__body">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    title: string
    current: number
    maxReached: number
    saved?: boolean
    hint?: string
    rule?: string
    items: Array<{ title: string; description?: string }>
  }>(),
  {
    rule: '修改先记在本页，最后点「保存到服务器」后才会生效。',
  }
)

const emit = defineEmits<{
  select: [index: number]
}>()

const stepStatus = (index: number) => {
  if (props.saved || index < props.current) return 'finish'
  if (index === props.current) return 'process'
  if (index <= props.maxReached) return 'finish'
  return 'wait'
}

const onStepClick = (index: number) => {
  if (index <= props.maxReached) emit('select', index)
}
</script>

<style scoped lang="less">
.amap-steps-panel {
  position: absolute;
  right: 16px;
  bottom: 16px;
  z-index: 20;
  pointer-events: auto;
  width: 440px;
  padding: 14px 16px 12px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.16);
}

.amap-steps-panel__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.amap-steps-panel__title {
  font-weight: 600;
  font-size: 15px;
}

.amap-steps-panel__rule {
  margin-bottom: 10px;
  color: #1677ff;
  font-size: 12px;
  line-height: 1.5;
}

.amap-steps-panel__hint {
  margin: 10px 0 12px;
  color: #64748b;
  font-size: 12px;
  line-height: 1.55;
  white-space: pre-wrap;
}

.amap-steps-panel__body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

:deep(.ant-steps-item-title) {
  font-size: 13px;
}

:deep(.ant-steps-item-description) {
  font-size: 12px;
}

:deep(.is-clickable) {
  cursor: pointer;
}
</style>
